import {createPinia, Pinia} from "pinia";

export const pinia: Pinia = createPinia();
